import React from 'react'

const Parent = ({ children }: {children:React.ReactNode}) => {
  return (
    <div>
      {children}
    </div>
  )
}

export default Parent
